import { slideDown, slideUp } from "../../helpers/utils/slide";

export const checkoutDeliveryToggle = () => {
    const checkbox = document.querySelector('#ship-to-different-address-checkbox');
    const shippingAddress = document.querySelector('.woocommerce-shipping-fields .shipping_address');
    
    if (checkbox !== null && shippingAddress !== null) {
        checkbox.addEventListener('change', (event) => {
            if (event.currentTarget.checked) {
                slideDown(shippingAddress, 300);
            } else {
                slideUp(shippingAddress, 300);
            }
        })
    }
}